<template>
  <div>
    <Form ref="searchForm" inline :label-width="70">
      <Form-item label="分类名称">
        <Input
          v-model="keywords"
          style="width:200px"
          placeholder="请输入分类名称关键字"
          clearable
          @keydown.native.prevent.enter="getList"
        />
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="getList">搜索</Button>
          <Button icon="md-undo" @click="keywords = '';getList(true)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <Button @click="addClassify" type="primary">新增分类</Button>
    <Modal v-model="addClassifyModal" :title="modalText" ref="modal">
      <div class="course-type">
        <Form ref="classifyForm" :rules="ruleValidate" :model="addClassifyInfo" :label-width="80">
          <FormItem label="所属分类">
            <p>{{addClassifyInfo.parent_name||"无"}}</p>
          </FormItem>
          <FormItem label="分类名称" prop="name">
            <Input style="width:300px" type="text" v-model="addClassifyInfo.name" />
          </FormItem>
          <FormItem label="排序" prop="sort">
            <Input style="width:300px" type="number" v-model="addClassifyInfo.sort" />
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="addClassifyModal = false">取消</Button>
        <Button type="primary" @click="save">确定</Button>
      </div>
    </Modal>
    <div class="content">
      <TreeGrid :rows="list" :columns="columns" :maxLevel="2" :formatter="formatter">
        <template slot-scope="{ row }" slot="c1">
          <span>
            {{row.name}}
            <span v-if="row.children_num!==undefined">（{{row.children_num}}）</span>
          </span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <Button @click="addClassify(row)" type="text" size="small" v-if="!row.parent_id">新增-</Button>
          <Button @click="editClassify(row)" type="text" size="small">编辑-</Button>
          <Button @click="deleteClassify(row)" type="text" size="small">删除</Button>
        </template>
      </TreeGrid>
    </div>
  </div>
</template>
<script>
export default {
  name: "GlobalCatagory",
  data() {
    return {
      loading: false,
      addClassifyModal: false,
      modalText: "新增分类",
      expandId: "",
      ruleValidate: {
        name: [{ required: true, message: "名称必须填写", trigger: "blur" }],
        sort: [{ required: true, message: "排序必须填写" }]
      },
      columns: [
        {
          title: "分类名称",
          key: "name",
          slot: "c1"
        },
        {
          title: "课程数量",
          key: "course_num",
          align: "center"
        },
        {
          title: "排序",
          key: "sort",
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          key: "address",
          width: 140
        }
      ],
      keywords: "",
      addClassifyInfo: {},
      list: []
    };
  },
  created() {
    this.getList();
  },
  mounted() {},
  methods: {
    addClassify(row) {
      this.addClassifyInfo = {};
      if (row.name) {
        this.addClassifyInfo = JSON.parse(JSON.stringify(row));
        this.addClassifyInfo.parent_name = row.name;
        this.addClassifyInfo.name = "";
        this.addClassifyInfo.sort = 0;
      } else {
        this.addClassifyInfo.parent_name = "无";
      }
      this.modalText = "新增分类";
      this.addClassifyModal = true;
    },
    editClassify(row) {
      this.addClassifyInfo = {};
      this.modalText = "编辑分类";
      this.addClassifyInfo = JSON.parse(JSON.stringify(row));
      this.addClassifyInfo.name = row.name;
      this.addClassifyInfo.sort = row.sort;
      this.addClassifyModal = true;
    },
    deleteClassify(row) {
      if (row.hasOwnProperty("children") && row.children.length > 0) {
        this.$Modal.warning({
          title: "提示",
          content: "<p>当前分类下含有子分类，无法删除</p>"
        });
        return;
      }
      if (row.course_num > 0) {
        this.$Modal.warning({
          title: "提示",
          content: "<p>当前分类下含有课程内容，无法删除</p>"
        });
        return;
      }
      this.$Modal.confirm({
        title: "提示",
        content: "<p>确定要删除该分类吗</p>",
        onOk: async () => {
          await this.$http.delete("/api/course/classify/" + row.id);
          this.$Message.deleteSuccess();
          this.getList();
        }
      });
    },
    async save() {
      this.$refs.classifyForm.validate(async valid => {
        if (!valid) {
          return;
        }
        if (this.modalText == "新增分类") {
          await this.$http.post("/api/course/classify", {
            title: this.addClassifyInfo.name,
            parent_id: this.addClassifyInfo.id || 0,
            sort: this.addClassifyInfo.sort
          });
          this.expandId =
            this.addClassifyInfo.parent_id == 0
              ? this.addClassifyInfo.id
              : this.addClassifyInfo.parent_id;
          this.getList(true);
        } else {
          await this.$http.put(
            "/api/course/classify/" + this.addClassifyInfo.id,
            {
              title: this.addClassifyInfo.name,
              parent_id: this.addClassifyInfo.parent_id || 0,
              id: this.addClassifyInfo.id,
              sort: this.addClassifyInfo.sort
            }
          );
          this.expandId =
            this.addClassifyInfo.parent_id == 0
              ? 0
              : this.addClassifyInfo.parent_id;
          this.getList();
        }
        this.addClassifyModal = false;
        this.$Message.saveSuccess();
      });
    },
    async getList(params) {
      if (params) {
        this.page = 1;
      }
      this.loading = true;
      let data = await this.$http.get("/api/course/classify", {
        keywords: this.keywords
      });
      data.forEach(item => {
        if (item.id == this.expandId || this.keywords != "") {
          item._expanded = true;
        }
      });
      this.loading = false;
      this.list = data;
      this.list.forEach(i => {
        if (i.children_num === 0) {
          i._disableExpand = true;
        }
      });
    },
    formatter(row) {
      if (!row.children) {
        return;
      }
      row.children.forEach(child => {
        child.parent_name = row.name;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
